import { FileItemRef, useFileUploadItem } from '@nhost/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { UploadFileCard } from '../cards';
import { isFileSizeOverLimit, MAX_FILE_SIZE } from './shared';

type NhostUploadFileComponentProps = {
  fileRef: FileItemRef;
  onDelete?: (fileId: string, file: File) => void;
  maxSize?: number;
};

export const NhostFileUploader: React.FC<NhostUploadFileComponentProps> = ({
  fileRef,
  onDelete,
  maxSize = MAX_FILE_SIZE,
}) => {
  const { t } = useTranslation('ui');
  const { isUploaded, isUploading, error } = useFileUploadItem(fileRef);
  const file = useMemo(() => fileRef.getSnapshot()?.context.file, [fileRef]);

  if (!file) {
    return null;
  }

  let errorMessage = error?.message;
  if (isFileSizeOverLimit(file.size, maxSize)) {
    errorMessage = t('upload.fileSizeExceedsLimit', { limit: maxSize });
  }

  return (
    <UploadFileCard
      file={file}
      error={errorMessage}
      isUploaded={isUploaded}
      isLoading={isFileSizeOverLimit(file.size) ? false : isUploading}
      onDelete={() => onDelete?.(fileRef.id, file)}
    />
  );
};
